// lightClient.js: every ArguMentor Light change goes through the lightConversation
// Cloud Function. The browser only reads conversations it is part of (database rules).
import { STRIPE_CONFIG } from '../../../shared.jsx';

async function authHeaders() {
  const user = window.firebaseAuth?.currentUser;
  if (!user || user.isAnonymous) throw new Error('Please sign in again.');
  return { Authorization: `Bearer ${await user.getIdToken()}`, 'Content-Type': 'application/json' };
}

// Resolves with the response body. Rejects with an Error carrying status and any extra
// fields the server sent (stop, upgrade, credits) so screens can react to them.
export async function light(action, payload = {}) {
  const response = await fetch(`${STRIPE_CONFIG.cloudFunctionUrl}/lightConversation`, {
    method: 'POST', headers: await authHeaders(), body: JSON.stringify({ action, ...payload }), cache: 'no-store',
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(body.error || 'Something went wrong. Please try again.'), { status: response.status, ...body });
  return body;
}

// One-time credit pack (50 messages, $2.99). No refunds.
export async function buyLightCredits() {
  const response = await fetch(`${STRIPE_CONFIG.cloudFunctionUrl}/createCheckoutSession`, {
    method: 'POST', headers: await authHeaders(),
    body: JSON.stringify({
      priceKey: 'light_credits_50',
      successUrl: `${window.location.origin}/free/together?billing=success`,
      cancelUrl: `${window.location.origin}/free/together?billing=cancelled`,
    }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || !body.url) throw new Error(body.error || 'Checkout is unavailable right now.');
  window.location.href = body.url;
}

export const shareUrl = code => `${window.location.origin}/free/together?join=${code}`;
